var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "148DFD2A-D0FB-460B-97FC-56145D476252") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-1366.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(1356.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    cx: 11,
    cy: 11,
    r: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-(1)",
    fill: "#979797",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C4.9347173,0 0,4.9347173 0,11 C0,17.0652827 4.9347173,22 11,22 C17.0652827,22 22,17.0652827 22,11 C22,4.9347173 17.0653275,0 11,0 Z M11,21.0434919 C5.46173161,21.0434919 0.956508093,16.5382684 0.956508093,11 C0.956508093,5.46173161 5.46173161,0.956508093 11,0.956508093 C16.5382684,0.956508093 21.0434919,5.46173161 21.0434919,11 C21.0434919,16.5382684 16.5382684,21.0434919 11,21.0434919 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,10 C7.69168584,10 5,12.915987 5,16.4999866 C5,16.7759854 5.20678316,17 5.46155178,17 C5.71632039,17 5.92310355,16.7759385 5.92310355,16.4999397 C5.92310355,13.4669533 8.20031442,10.9999799 11,10.9999799 C13.7996856,10.9999799 16.0768964,13.4669533 16.0768964,16.4999397 C16.0768964,16.7759385 16.2836796,17 16.5384482,17 C16.7932168,17 17,16.7759385 17,16.4999397 C17,12.915987 14.3083142,10 11,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,3 C9.57002424,3 8,4.56997737 8,6.5 C8,8.43002263 9.56997737,10 11.5,10 C13.4300226,10 15,8.42997576 15,6.5 C15,4.57002424 13.4300226,3 11.5,3 Z M11.5,8.99997321 C10.1220218,8.99997321 9.00002679,7.87797822 9.00002679,6.5 C9.00002679,5.12202178 10.1220218,4.00002679 11.5,4.00002679 C12.8779782,4.00002679 13.9999732,5.12202178 13.9999732,6.5 C13.9999732,7.87797822 12.8780251,8.99997321 11.5,8.99997321 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.75ed0e16796034ee1dbf47479267dabe.svg";
export { ForwardRef as ReactComponent };